export const CHECKOUT_TYPE_ONE_STEP = 'one-step'
export const CHECKOUT_TYPE_TWO_STEPS = 'two-steps'
export const CHECKOUT_TYPE_AMAZON_TWO_STEPS = 'amazon-two-steps'
export const CHECKOUT_TYPE_PAYPAL_TWO_STEPS = 'paypal-two-steps'
export const CHECKOUT_TYPE_PAY_BY_LINK = 'pay-by-link-one-step'

export const defaultCheckoutType = CHECKOUT_TYPE_TWO_STEPS

const AMAZON_CHECKOUT_TYPES = [CHECKOUT_TYPE_AMAZON_TWO_STEPS]
const PAYPAL_CHECKOUT_TYPES = [CHECKOUT_TYPE_PAYPAL_TWO_STEPS]
const PAY_BY_LINK_CHECKOUT_TYPES = [CHECKOUT_TYPE_PAY_BY_LINK]

export const isAmazonCheckout = (type) => AMAZON_CHECKOUT_TYPES.includes(type)
export const isPayPalCheckout = (type) => PAYPAL_CHECKOUT_TYPES.includes(type)
export const isPayByLinkCheckout = (type) => PAY_BY_LINK_CHECKOUT_TYPES.includes(type)
